import { logger } from '@teko/log';
import { useEffect, useState } from 'react';
import { LoyaltyMemberInfo } from '@teko/terra-bff';
import { useServices, useTenantConfig } from 'contexts';

export const useLoyalty = () => {
  const [loyaltyMemberInfo, setLoyaltyMemberInfo] =
    useState<LoyaltyMemberInfo>();
  const { loyaltyNetworkConfig } = useTenantConfig();
  const [loadingLoyaltyData, setLoadLoyaltyData] = useState(true);
  const [redemptionCode, setRedemptionCode] = useState<string>();
  const { terraService, loyaltyService } = useServices();

  const getData = async () => {
    try {
      setLoadLoyaltyData(true);
      const loyaltyClientId = loyaltyService.networkClientId;
      if (loyaltyClientId) {
        const { data } = await terraService.getLoyaltyMemberInfo(
          loyaltyClientId,
        );
        setLoyaltyMemberInfo(data);
      }

      const encryptedMemCode =
        await loyaltyService.getEncryptedMembershipCode();
      setRedemptionCode(encryptedMemCode);
    } catch (e: any) {
      logger.error(e);
    } finally {
      setLoadLoyaltyData(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return {
    loyaltyMemberInfo,
    networkConfig: loyaltyNetworkConfig,
    loadingLoyaltyData,
    redemptionCode,
  };
};
